require('./brokerRightsBuyStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const trim = require('lodash/string/trim');
const moment = require('moment');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const {
    CHARGE_ACCOUNT_PREFIX,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_PRODUCT_TYPE_CAPITAL_INCREASE
} = require('constants/index');
const {
    BROKER_RIGHTS_BUY_ID
} = require('constants/operationTypes');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const WebappRender = require('components/conditionalRender/webappRender');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';
const SubscriptionLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/subscriptionLegalConfirmation/subscriptionLegalConfirmation');
const ExAntCostRightBuy = require('components/broker/brokerRightsBuy/brokerRightsBuySteps/brokerRightsBuyStep2/components/exAntCostRightBuy.js')
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKTooltip = require('commonsComponents/OKTooltip');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const { OKLink } = require('commonsComponents/OKLink');

// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const {
    BROKER_CORPORATE_OPERATIONS_SUBSCRIPTION_PRODUCT_TYPE,
    BROKER_ORDER_TYPE_SUBSCRIPTION,
    DATE_FORMAT_API
} = require('constants/index');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');

class BrokerRightsBuyStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY,
        };
        this.getImmOperation = this.getImmOperation.bind(this);
        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);
    }

    getImmOperation() {
        return this.props.immBrokerSubscription.get('value');
    }

    handleLegalYesNoOptionChange(value) {
        this.setState({
            selectedLegalConfirmationValue: value
        });
    }

    getPrecontractualMailParams() {
        const { immProfileFields, immBrokerSubscription } = this.props;

        const controlDigit = trim(immBrokerSubscription.get('digitodecontrol'));
        const productNumber = trim(immBrokerSubscription.getIn(['contract', 'product']));
        const contractNumber = trim(immBrokerSubscription.getIn(['contract', 'number']));
        const idContract = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;

        const owner = trim(immBrokerSubscription.get('owner'));
        const momentEndDate = moment(immBrokerSubscription.getIn(['value', 'endDate']));

        return {
            productKID: '',
            contract: '',
            marketingReport: '',
            infoCcv: '',
            idOrder: '',
            market: '',
            termValidity: momentEndDate.format(DATE_FORMAT_API),
            holders: owner,
            leafletSusbcription: trim(immBrokerSubscription.get('linkTriptico')),
            cnmvDocumentation: trim(immBrokerSubscription.get('linkCNMV')),
            ccv: idContract,
            ccc: '',
            idContract: idContract,
            email: trim(PersonalDataHelper.getEmail(immProfileFields)),
            clientAlias: trim(immProfileFields.get('nombreCliente')),
            isin: trim(immBrokerSubscription.getIn(['value', 'isin'])),
            isinDescribe: trim(immBrokerSubscription.getIn(['value', 'descriptionValue'])),
            orderType: BROKER_ORDER_TYPE_SUBSCRIPTION,
            productType: BROKER_CORPORATE_OPERATIONS_SUBSCRIPTION_PRODUCT_TYPE,
            sharesNumber: '',
            sharesAmount: '',
            orderCondition: '',
            conditionPrize: '',
            currency: ' ',
            mifidWarningText: '',
            dateTime: '',
        };
    }

    buildExAnteData() {
        const { immBrokerRightsBuy } = this.props;
        return (
            !!immBrokerRightsBuy.get("exAnteCostsList") &&
            immBrokerRightsBuy
                    .get("exAnteCostsList")
                    .map((item, index) => (
                        <BrokerExAntSection
                            context="brokerRightsSell"
                            eventCategory="orden venta acciones/paso 2"
                            section={item}
                            key={index}
                            complexTooltip={true}
                        />
                    ))
        );
    }

    builSubscriptionLegalConfirmation(bookletLabel, CNMVLabel) {
        const {
            immBrokerSubscription,
            immCorporatesOperations,
            immProfileFields,
            immPreContractualMail,
            sendPreContractualMail,
            resetPrecontractualMail,
            requestProfile,
            immFlagBasedFeatures
        } = this.props;
        const immCorporatesOperation = immBrokerSubscription.get('value');
        const currency = immCorporatesOperations.getIn(['selectedContract', 'associatedAccount', 'balance', 'currency']);
        const bookletLink = (
            <OKLink modifier="emphasize" to={immBrokerSubscription.get('linkTriptico')} target="_blank">
                {bookletLabel}
            </OKLink>
        );
        const CNMVLink = (
            <OKLink modifier="emphasize" to={immBrokerSubscription.get('linkCNMV')} target="_blank">
                {CNMVLabel}
            </OKLink>
        );
        const showExAntCostRightBuy = immFlagBasedFeatures.get('wealth_rights_buy_show_costs')
        const exAnteSection = showExAntCostRightBuy ? (
            <div className="broker-rights-sell-step2__ex-ante-container-cc">
                {this.buildExAnteData()}
            </div>
        ) : null;

        return (
            <SubscriptionLegalConfirmation
                immCorporatesOperation={immCorporatesOperation}
                currency={currency}
                legalinformationLinks={[bookletLink, CNMVLink]}
                immPreContractualMail={immPreContractualMail}
                sendMail={sendPreContractualMail}
                sendMailParams={this.getPrecontractualMailParams()}
                resetMailState={resetPrecontractualMail}
                immProfileFields={immProfileFields}
                requestProfile={requestProfile}
                selectedYesNoOption={this.state.selectedLegalConfirmationValue}
                onYesNoOptionChange={this.handleLegalYesNoOptionChange}
                exAnteCost={exAnteSection}
            />
        );
    }

    render() {
        const {
            immBrokerRightsBuy,
            immCorporatesOperations,
            handleDisclaimerCheckboxChange,
            setDocumentsRead,
            immFlagBasedFeatures,
            fetchExAntCostBuyRight,
        } = this.props;
        const showExAntCostRightBuy = immFlagBasedFeatures.get('wealth_rights_buy_show_costs')
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const operationParams = {
            chargeAccount:
                CHARGE_ACCOUNT_PREFIX +
                selectedContract.getIn(['contract', 'product']) +
                selectedContract.getIn(['contract', 'number']),
            bondsNumber: immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'rightsQuantity'])
        };
        const operative = formatText('operatives-purchaseOfRights');
        const immStep = immBrokerRightsBuy.getIn(['steps', SECOND_STEP]);
        const selectedCorporateOperationIndex = immBrokerRightsBuy.get('selectedCorporateOperationIndex');
        const operation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex], false);
        const disclaimerChecked = immStep.get('isDisclaimerChecked');
        const disclaimerErrorVisible = immStep.get('disclaimerIsDirty') && !disclaimerChecked;
        const disclaimerErrorMsg = formatText('broker-broker_rightsBuyStep2DisclaimerTextCheckboxErrorMsg');
        const isin = operation.get('isin')
        const iso = operation.get('iso')
        const descriptionValue = operation.get('descriptionValue')
        const showWarning = immStep.get('showWarning')

        let documentsNotRead = null;
        if (showWarning) {
            documentsNotRead = (
                <div className="broker-rights-buy-step2__warning-message">
                    <OKMessage type="warning">
                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                    </OKMessage>
                </div>
            )
        }

        let signaturePattern = null;
        if (disclaimerChecked || (this.state.selectedLegalConfirmationValue === SELECTED_VALUES.YES)) {
            signaturePattern = (
                <div className="broker-rights-buy-step2__group-div">
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                        <BlockInfo extraClass="broker-legal-confirmation__block-info">
                            <FormattedText
                                value="broker-rightsBuyStep2InfoMessageBody"
                                className="broker-rights-buy-step2__info-message-body"
                            />
                        </BlockInfo>
                    </ContactCenterRender>
                    <SignaturePattern
                        operationType={BROKER_RIGHTS_BUY_ID}
                        operationParams={operationParams}
                        printTitleValue={'brokerLegalConfirmation-title'}
                    />
                </div>
            );
        }

        const bookletLabel = <FormattedText value="brokerSubscription-informativeMessageBookletLabel"/>
        const CNMVLabel = <FormattedText value="brokerSubscription-informativeMessageCNMVLabel"/>

        const disclaimerLabel = (
            <FormattedTextWithComponents
                value="broker-broker_rightsBuyStep2DisclaimerText"
                injectedComponents={[bookletLabel,CNMVLabel]}
            />
        );
        const legalConfirmation = this.builSubscriptionLegalConfirmation(bookletLabel, CNMVLabel);

        return (
            <article className="broker-rights-buy-step2">
                <header className="broker-rights-buy-step2__header">
                    <h2 className="broker-rights-buy-step2__header-title">
                        <FormattedText value="broker-rightsBuyStep2HeaderTitle" />
                    </h2>
                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>
                    <h4 className="broker-rights-buy-step2__header-subtitle">
                        <FormattedText value="broker-rightsBuyStep2HeaderSubtitle" />
                    </h4>
                </header>
                <WebappRender>
                    <div className="broker-rights-buy-step2__group-div">
                        <div className="broker-rights-buy-step2__doc-box">
                            <BrokerLegalDocumentation
                                isin={isin}
                                iso={iso}
                                productDefinition={descriptionValue}
                                productType={BROKER_PRODUCT_TYPE_CAPITAL_INCREASE}
                                reportCompleted={() => setDocumentsRead()}
                            />
                        </div>
                        {showExAntCostRightBuy && !__CONTACT_CENTER__ && (
                            <section>
                                <ExAntCostRightBuy
                                    fetchExAntCostBuyRight={fetchExAntCostBuyRight}
                                    immBrokerRightsBuy={immBrokerRightsBuy}
                                />
                            </section>
                        )}
                        <OKMessage type="informative">
                            <FormattedText
                                value="broker-rightsBuyStep2InfoMessageHead"
                                className="broker-rights-buy-step2__info-message-head"
                            />
                            <FormattedText
                                value="broker-rightsBuyStep2InfoMessageBody"
                                className="broker-rights-buy-step2__info-message-body"
                            />
                        </OKMessage>
                    </div>
                    {documentsNotRead}
                    <OKTooltip
                        content={<FormattedText value={'planLegalDocumentDisclaimer-warningTooltip'}/>}
                        offset={[-50, -5]}
                        placement={'topLeft'}
                        target={
                            <div className="broker-rights-buy-step2__checkbox-container">
                                <OKCheckbox
                                    idName="brokerRightsBuyCheckbox"
                                    errorState={disclaimerErrorVisible}
                                    errorMessage={disclaimerErrorMsg}
                                    label={disclaimerLabel}
                                    onChange={handleDisclaimerCheckboxChange}
                                    value={disclaimerChecked}
                                />
                            </div>
                        } />
                </WebappRender>
                <ContactCenterRender>{legalConfirmation}</ContactCenterRender>
                {signaturePattern}
            </article>
        );
     }
}

BrokerRightsBuyStep2.propTypes = {
    handleDisclaimerCheckboxChange: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immBrokerRightsBuy: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immBrokerSubscription: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    requestProfile:  PropTypes.func.isRequired,
    resetPrecontractualMail:  PropTypes.func.isRequired,
    sendPreContractualMail:  PropTypes.func.isRequired,
    printLegalTextProductDescription:  PropTypes.func.isRequired,
    selectedCorporateOperation: PropTypes.object.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    fetchExAntCostBuyRight: PropTypes.func.isRequired
}

module.exports.constructor = BrokerRightsBuyStep2;
module.exports.BrokerRightsBuyStep2 = BrokerRightsBuyStep2;
